import React from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { withStyles } from "@material-ui/core";

export const customTabMuiStyle = {
  "&:hover": {
    color: "#333f4c",
    opacity: 1,
  },
  "&": {
    color: "#1A273A",
    fontWeight: 600,
    backgroundColor: "rgb(237 244 255)",
  },
};

export const CustomTabs = withStyles({
  root: {
    "& .MuiTab-wrapper": {
      fontFamily: "Mulish",
      fontStyle: "normal",
      fontWeight: "bold",
      fontSize: "16px",
      lineHeight: "30px",
    },
  },
  indicator: {
    backgroundColor: "#0765FF",
    "& > span": {
      maxWidth: "40px !important",
      width: "100%",
      backgroundColor: "#0765FF",
      height: "3px",
    },
  },
})(Tabs);

export const CustomTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    padding: "12px",
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: `10px`,
    color: "#808080",
    borderRadius: "12px",
    minWidth: "auto",

    "&:hover": {
      color: "#16191f",
      opacity: 1,
    },
    "&$selected": {
      fontWeight: 600,
      fontFamily: "Mulish",
      fontStyle: "normal",
      fontWeight: "bold",
      fontSize: "24px",
      lineHeight: "30px",
      padding: "12px",
      borderRadius: "12px",
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);
